import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import {
  OptionButtonToggleGroup,
  sizesButtonToggleGroup,
  variantsButtonToggleGroup,
} from '../button-toggle-group/button-toggle-group.component';

@Component({
  selector: 'app-button-toggle-group-form',
  templateUrl: './button-toggle-group-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ButtonToggleGroupFormComponent),
      multi: true,
    },
  ],
})
export class ButtonToggleGroupFormComponent
  implements ControlValueAccessor, OnInit
{
  @Input() variant: (typeof variantsButtonToggleGroup)[number] = 'primary';
  @Input() size: (typeof sizesButtonToggleGroup)[number] = 'small';

  initialValue: Value | null = null;
  value: Value | null = null;
  disabled = false;
  control!: NgControl;

  private _options: OptionButtonToggleGroup[] = [];

  constructor(private injector: Injector) {}

  get isError() {
    return this.control.touched && this.control?.errors !== null;
  }

  get errorMessage() {
    return this.isError ? 'Campo obrigatório' : null;
  }

  get options() {
    return this._options;
  }
  @Input({ required: true }) set options(options: OptionButtonToggleGroup[]) {
    this._options = options;
  }

  ngOnInit() {
    this.control = this.injector.get(NgControl);
  }

  handleChange(val: Value) {
    this.onChange(val);
    this.onTouched();
  }

  writeValue(value: Value): void {
    this.value = value;
    this.initialValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // eslint-disable-next-line
  private onChange = (val: Value | null) => {};
  private onTouched = () => {};
}
type Value = OptionButtonToggleGroup['value'];
